import { gql } from '@apollo/client';

export const QUERY_DAILY_BUBBLE_FINISHED_PAGE = gql`
  query DailyBubbleFinished {
    dailyBubbleFinishedPage {
      data {
        attributes {
          messageSection {
            youAreDoneTitle
            comeBackTitle
          }
          continueYourWeelbeingJourneyTitle
          resourcesTitle
          resourceDescription
          toolkitsTitle
          toolkitsDescription
        }
      }
    }
  }
`;
